import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  AllocationUploadResponseData,
  IDownloadSampleAllocationRequest,
  UploadRequestPayload,
  UploadState,
} from 'redux/types/Allocation.types';

export const uploadAllocationInitialState: UploadState = {
  loading: false,
  error: null,
  success: false,
  warning: '',
  data: {
    allocation_id: '',
    product: [],
    bucket: [],
    allocation_name: '',
  },
  isSampleAllocationDownloading: false,
  sampleDownloadError: null,
};

const uploadAllocationSlice = createSlice({
  name: 'uploadAllocationFile',
  initialState: uploadAllocationInitialState,
  reducers: {
    uploadRequest(state, action: PayloadAction<UploadRequestPayload>) {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    uploadSuccess(state, action: PayloadAction<AllocationUploadResponseData>) {
      state.loading = false;
      state.success = true;
      state.error = null;
      state.data = action.payload.data;
      state.warning = action.payload.warning;
    },
    uploadFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action?.payload;
      state.success = false;
    },
    downloadSampleAllocation(
      state,
      action: PayloadAction<IDownloadSampleAllocationRequest>
    ) {
      state.sampleDownloadError = null;
      state.isSampleAllocationDownloading = true;
    },
    downloadSampleAllocationSuccess(
      state,
      action: PayloadAction<AllocationUploadResponseData>
    ) {
      state.sampleDownloadError = null;
      state.isSampleAllocationDownloading = false;
    },
    downloadSampleAllocationFailure(state, action: PayloadAction<string>) {
      state.sampleDownloadError = action?.payload;
      state.isSampleAllocationDownloading = false;
    },
    resetUploadAllocationState: () => uploadAllocationInitialState,
  },
});

export const {
  uploadRequest,
  uploadSuccess,
  uploadFailure,
  downloadSampleAllocation,
  downloadSampleAllocationSuccess,
  downloadSampleAllocationFailure,
  resetUploadAllocationState,
} = uploadAllocationSlice.actions;

export default uploadAllocationSlice.reducer;
